module.exports = __webpack_public_path__ + "static/media/26.93d30fbf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Carousel/CarouselMedia/26.jpg
// module id = 187
// module chunks = 0